export const Weather = {
    location: 'Tampere',
    date: '19-05-1905',
    tempMax: 22,
    tempMin: 14,
    conditions: 'Sunny',
};